export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
          关于我们
        </h2>

        <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            樱花漫画成立于2020年，是一家专注于为漫画爱好者提供优质阅读体验的平台。
            我们致力于打造一个汇聚日漫、韩漫、国漫的综合性漫画社区，让每一位读者都能在这里找到属于自己的漫画世界。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            从高清离线下载到智能追更提醒，从个性化收藏夹到多端无缝同步，我们持续打磨每一个细节，
            只为给你带来最舒适的漫画阅读体验。平台目前收录超过两万部漫画作品，涵盖热血、恋爱、悬疑、奇幻、搞笑等全品类题材。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            我们相信，好的漫画值得被更多人看见。樱花漫画将持续引进优质漫画内容，优化阅读体验，
            让漫画成为连接人与人之间的温暖纽带。感谢每一位读者的一路相伴，未来我们一起追更。
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-500 font-heading">2万+</div>
              <div className="text-xs text-foreground-500 mt-1">收录漫画</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-500 font-heading">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">活跃读者</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-secondary-500 font-heading">每日更新</div>
              <div className="text-xs text-foreground-500 mt-1">同步追更</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}